import { render, staticRenderFns } from "./FloorManagement.vue?vue&type=template&id=37bc20a0&scoped=true"
import script from "./FloorManagement.vue?vue&type=script&lang=js"
export * from "./FloorManagement.vue?vue&type=script&lang=js"
import style0 from "./FloorManagement.vue?vue&type=style&index=0&id=37bc20a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc20a0",
  null
  
)

export default component.exports